import React from 'react';
import { Doughnut, Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
} from 'chart.js';

const generateColorPalette = (count) => {
    const palette = [
        '#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0',
        '#9966FF', '#FF9F40', '#8BC34A', '#E91E63',
        '#3F51B5', '#CDDC39', '#00BCD4', '#9C27B0',
        '#F44336', '#607D8B', '#795548', '#009688',
        '#FF6F61', '#6B5B95', '#88B04B', '#F7CAC9',
        '#92A8D1', '#955251', '#B565A7', '#009B77',
        '#DD4124', '#D65076', '#45B8AC', '#EFC050',
        '#5B5EA6', '#9B2335', '#DFCFBE', '#55B4B0'
      ];
      
  
    // If more colors are needed, repeat with a slight modification
    const colors = [];
    for (let i = 0; i < count; i++) {
      colors.push(palette[i % palette.length]);
    }
  
    return colors;
  };
  

ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  Title
);

const AdPartnerCharts = ({ data }) => {
  const partnerNames = data.map(p => p.ad_partner_name);
  const revenueData = data.map(p => parseFloat(p.revenue_inr));
  const impressionData = data.map(p => parseInt(p.impressions));
  const clickData = data.map(p => parseInt(p.clicks));
  const colors = generateColorPalette(data.length);

  const doughnutChartData = {
    labels: partnerNames,
    datasets: [
      {
        label: 'Revenue Share',
        data: revenueData,
        backgroundColor: colors,
        borderWidth: 1,
      },
    ],
  };

  const barChartData = {
    labels: partnerNames,
    datasets: [
      {
        label: 'Impressions',
        data: impressionData,
        backgroundColor: 'rgba(54, 162, 235, 0.6)',
      },
      {
        label: 'Clicks',
        data: clickData,
        backgroundColor: 'rgba(255, 99, 132, 0.6)',
      },
    ],
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 p-4">
      {/* Doughnut Chart */}
      <div className="bg-white p-4 rounded shadow max-h-[400px]">
        <h3 className="text-lg font-semibold mb-2">Revenue Share </h3>
        <Doughnut
          data={doughnutChartData}
          options={{
            plugins: {
              legend: { position: 'right' },
              title: {
                display: true,
                text: 'All Values are in Indian Rupees',
              },
              tooltip: {
                callbacks: {
                  label: ctx => `${ctx.label}: ₹ ${ctx.raw.toLocaleString()}`,
                },
              },
            },
          }}
        />
      </div>

      {/* Bar Chart */}
      <div className="bg-white p-4 rounded shadow">
        <h3 className="text-lg font-semibold mb-2">Impressions & Clicks</h3>
        <Bar
          data={barChartData}
          options={{
            responsive: true,
            plugins: {
              legend: { position: 'top' },
              title: {
                display: true,
                text: 'Partner-wise Engagement',
              },
            },
            scales: {
              x: {
                ticks: {
                  maxRotation: 45,
                  minRotation: 30,
                },
              },
              y: {
                beginAtZero: true,
              },
            },
          }}
        />
      </div>
    </div>
  );
};

export default AdPartnerCharts;
